import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/wk_type",
    name: "wk_type",
    redirect: "/wk_type/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wk_type_index",
        meta: {title: "工作类型", isIndex: true, keepAlive: true},
        component: () => import("@/pages/wk/type/index")
      }
    ]
  },
  {
    path: "/wk_work",
    name: "wk_work",
    redirect: "/wk_work/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wk_work_index",
        meta: {title: "工作定义", isIndex: true, keepAlive: true},
        component: () => import("@/pages/wk/work/index")
      },
      {
        path: "inspectionIndex",
        name: "wk_work_inspectionIndex",
        meta: {title: "巡检定义", isIndex: true, keepAlive: true},
        component: () => import("@/pages/wk/work/inspectionIndex")
      },
      {
        path: "edit",
        name: "wk_work_edit",
        meta: {title: "编辑工作定义", isIndex: false, keepAlive: false},
        component: () => import("@/pages/wk/work/edit")
      },
      {
        path: "view",
        name: "wk_work_view",
        meta: {title: "查看工作定义", isIndex: false, keepAlive: false},
        component: () => import("@/pages/wk/work/view")
      }
    ]
  },
  {
    path: "/wk_datahandle",
    name: "wk_datahandle",
    redirect: "/wk_datahandle/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wk_datahandle_index",
        meta: {title: "数据入库",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/wk/datahandle/index")
      }
    ]
  },
  {
    path: "/wk_dataprocessmode",
    name: "wk_dataprocessmode",
    redirect: "/wk_dataprocessmode/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "wk_dataprocessmode_index",
        meta: {title: "数据处理方式",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/wk/dataprocessmode/index")
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/wk.js